import React, { useCallback } from 'react';
import TrashCan from '@uber/base-icons/trash-can';
import { useStyletron } from 'baseui';
import { Button, KIND as BUTTON_KIND, SIZE as BUTTON_SIZE } from 'baseui/button';
import { LabelXSmall, ParagraphXSmall } from 'baseui/typography';
import type { TrackSpanT } from '../../../types/frame-timeline-v4';
type AnnotationSpanPopoverContentPropsT = {
  annotationId: string;
  span: TrackSpanT;
  close: () => void;
  onDelete?: (params: {
    annotationIdx: string;
    frameSpan: {
      start: number;
      end: number;
    };
  }) => void;
};
export const AnnotationSpanPopoverContent = ({
  annotationId,
  span,
  close,
  onDelete
}: AnnotationSpanPopoverContentPropsT) => {
  const [css, theme] = useStyletron();
  const handleDelete = useCallback(() => {
    onDelete?.({
      annotationIdx: annotationId,
      frameSpan: {
        start: span.start,
        end: span.end
      }
    });
    close();
  }, [onDelete, annotationId, span, close]);
  const cellClass = css({
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: theme.sizing.scale300
  });
  const fieldClass = css({
    display: 'flex',
    alignItems: 'center',
    height: theme.sizing.scale850,
    paddingLeft: theme.sizing.scale300,
    paddingRight: theme.sizing.scale300,
    backgroundColor: theme.colors.backgroundTertiary,
    borderRadius: theme.borders.radius200,
    boxSizing: 'border-box'
  });
  const renderField = (label: string, value: number) => <div className={cellClass}>
      <LabelXSmall margin={0}>{label}</LabelXSmall>
      <div className={fieldClass}>
        <ParagraphXSmall color={theme.colors.contentTertiary} margin={0}>
          {value + 1}
        </ParagraphXSmall>
      </div>
    </div>;
  return <div className={css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: theme.sizing.scale300,
    width: '163px'
  })}>
      <div className={css({
      display: 'flex',
      gap: theme.sizing.scale300
    })}>
        {renderField('Start', span.start)}
        {renderField('End', span.end)}
      </div>
      <Button kind={BUTTON_KIND.tertiary} size={BUTTON_SIZE.xSmall} startEnhancer={<TrashCan size={12} />} onClick={handleDelete} overrides={{
      BaseButton: {
        style: {
          width: '100%',
          borderRadius: theme.borders.buttonBorderRadius
        }
      }
    }}>
        Delete
      </Button>
    </div>;
};